<template>
  <div v-if="resumed" class="event-list-item" :style="{backgroundColor: color}">
    <span class="event-title">{{ course.curso }}</span>
  </div>

  <b-card v-else no-body class="mb-7" :style="{borderColor: color}">
    <b-card-header :style="cardHeaderColor">
      <h3 class="event-card-title">{{ course.curso }}</h3>

      <v-menu offset-y :nudge-width="100" :nudge-left="110">
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" class="card-menu-icon">mdi-dots-vertical</v-icon>
        </template>

        <v-list>
          <v-list-item v-if="false">
            <v-list-item-title>Editar</v-list-item-title>
          </v-list-item>

          <v-list-item @click="deleteCourseTasks">
            <v-list-item-title>Excluir</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </b-card-header>

    <b-card-body>
      <v-list v-for="module in course.modulos" :key="module.id">
        <h4 class="module-title">{{ module.modulo }}</h4>

        <v-list-item v-for="task in module.tarefas" :key="task.id" class="task-list-item">
          <v-list-item-content class="task-list-item-container">
            <span class="task-list-item-title" @click="openTask(task)">
              {{ task.title }}
            </span>

            <div class="task-list-item">
              <v-icon small class="task-list-item-icon">{{ task.icon }}</v-icon>
              <span>{{ task.material }}</span>
            </div>
          </v-list-item-content>

          <v-checkbox class="task-list-item-check" hide-details color="#1B2231" label="Marcar como concluído"
                      v-model="tasksCompletion[task.id]"
                      @change="changeTaskStatus(task.id, tasksCompletion[task.id])"/>
        </v-list-item>
      </v-list>
    </b-card-body>
  </b-card>
</template>

<script>
import "./style.scss"
import {mapActions} from "vuex";
import PlataformApi from "@/services/plataformApi";

export default {
  name: "EventContent",

  props: {
    id: {type: Number, required: true},
    course: {type: Object, required: true},
    resumed: {type: Boolean, required: true},
    color: {type: String, required: true}
  },

  computed: {
    cardHeaderColor() {
      return {
        backgroundColor: this.color,
        borderColor: this.color
      }
    },

    tasksCompletion() {
      let tasksCompletionArray = []

      this.course.modulos.forEach(module => {
        module.tarefas.forEach(task => {
          tasksCompletionArray[task.id] = task.concluded
        })
      })

      return tasksCompletionArray
    },
  },

  methods: {
    ...mapActions(['completeOpenedTask', 'completeOrResetTask', 'removeEventDayCourses']),

    deleteCourseTasks() {
      let taskIds = []

      this.course.modulos.forEach(module => {
        module.tarefas.forEach(task => {
          taskIds.push(task.id)
        })
      })

      const params = {
        courseIds: [this.id],
        scheduleId: this.course.scheduleId,
        eventDayId: this.course.eventDayId,
        taskIds,
      }

      this.removeEventDayCourses(params)
    },

    changeTaskStatus(taskId, status) {
      const params = {
        eventDayId: this.course.eventDayId,
        scheduleId: this.course.scheduleId,
        status,
        taskId,
      }

      this.completeOrResetTask(params)
    },

    openTask(task) {
      if (task.isPdf) {
        PlataformApi.registraVisualizacaoPdf(task.pdfId)
      }

      const params = {
        courseId: this.id,
        eventDayId: this.course.eventDayId,
        scheduleId: this.course.scheduleId,
        status: true,
        taskId: task.id,
      }

      if (!this.tasksCompletion[task.id]) {
        this.completeOpenedTask(params)
      }
      window.open(task.customUrl, '_blank')
    }
  }
}
</script>
